import { Modal } from "@material-ui/core";
import { ReactElement } from "react";
import { CSSProperties } from "styled-components";

interface ModalComponetProps {
    open: boolean;
    children: ReactElement;
    onClose: () => void;
    style?: CSSProperties
    hiddenScroll?: boolean;
}
interface ModalFooterProps {
    children: ReactElement;
    className?:string
}

interface ModalTitleProps {
    buttonList: Array<ReactElement>;
    label: string;
    color: string;
    onClose:()=>void;
    showIconExit: boolean;
    className?:string
    backButton?:()=>void;
}

interface ModalAlertTitleProps {
    buttonList: Array<ReactElement>;
    label: string;
    color: string;
}

export function ModalTitle(props: ModalTitleProps) {
    //Services__Title-InnerHealth
    //Services__Title-Patient
    const backButton = () =>{
        props.backButton ? props.backButton() : props.onClose()
    } 
    return (
        <div className="modal-primary__header">
            <p className="Title5">
                {/* <em data-testid="closeButton" className="far fa-arrow-left" onClick={backButton}/> */}
                {props.label}
            </p>
            <i
                data-testid="closeButton"
                className="far fa-times"
                onClick={() => props.onClose()}
            />
        </div>
    );
}
export function ModalAlertTitle(props: ModalAlertTitleProps) {
    return (
        <div
            className="Title5"
            style={{ background: props.color }}
        >
            {props.label}
            <div className="Services__TitleButtons">
                {props.buttonList.map((elemen, i) => elemen)}
            </div>
        </div>
    );
}
export function ModalFooter(props: ModalFooterProps) {
    return <div className="Services__ButtonCtr">{props.children}</div>;
}

export default function ModalComponet(props:ModalComponetProps){
    return (
        <Modal
            open={props.open}
            onClose={() => props.onClose()}
        >
            
            <div className="modal-primary" style={props.style}>{props.children}</div>
        
        </Modal>
    );
}

const TITLEDEFAULT = {
    buttonList: [],
    color: "",
    label:"",
    showIconExit: true
}
ModalTitle.defaultProps = TITLEDEFAULT;

ModalAlertTitle.defaultProps = TITLEDEFAULT;

ModalComponet.defaultProps = {
    open:false,
    children:null,
    onClose:()=>null
}